import type { ReactNode } from 'react';
import {
	FormInput as FormInputDS,
	type FormInputProps as FormInputPropsDS,
	type FormITextareaProps as FormTextareaPropsDS,
	FormTextarea as FormTextareaDS,
} from '@gov-design-system-ce/react-form';
import { MessageNodeContext, MessageWrapper } from './MessageWrapper';

export interface FormInputProps<Value = string> extends Omit<
	FormInputPropsDS<Value>,
	'classNames' | 'messageWrapper'
> {
	/** Render a ReactNode (e.g. markdown) below the DS-managed messages. */
	messageNode?: ReactNode;
}

export const FormInput = <Value = string,>({
	messageNode,
	...props
}: FormInputProps<Value>) => {
	const input = (
		<FormInputDS<Value>
			{...props}
			label={{ size: 'm', ...props.label }}
			field={{ size: 'm', ...props.field }}
			messages={props.messages ?? { messages: [] }}
			messageWrapper={MessageWrapper}
		/>
	);
	return messageNode ? (
		<MessageNodeContext.Provider value={messageNode}>
			{input}
		</MessageNodeContext.Provider>
	) : (
		input
	);
};

export interface FormTextAreaProps extends Omit<
	FormTextareaPropsDS,
	'classNames' | 'messageWrapper'
> {
	/** Render a ReactNode (e.g. markdown) below the DS-managed messages. */
	messageNode?: ReactNode;
}

export const FormTextarea = ({ messageNode, ...props }: FormTextAreaProps) => {
	const textarea = (
		<FormTextareaDS
			{...props}
			label={{ size: 'm', ...props.label }}
			field={{ size: 'm', ...props.field }}
			messages={props.messages ?? { messages: [] }}
			messageWrapper={MessageWrapper}
		/>
	);
	return messageNode ? (
		<MessageNodeContext.Provider value={messageNode}>
			{textarea}
		</MessageNodeContext.Provider>
	) : (
		textarea
	);
};
